import ProductApi from "@/services/api/productApi";

const ProductApiService = new ProductApi();

export default {
  inject: ["parentValidator"],
  props: {
    productVariant: {
      type: Object,
    },
    product: {
      type: Object,
    },
    formErrors: {
      type: Object,
    },
    user: {
      type: Object,
    },
    testerProducts: {
      type: Array,
    },
    selectedBrand: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    openVariantImageModal,
    updateVariantValue,
    removeVariantFromList,
    addTester,
    removeTester,
    selectTestVariant,
    selectTestProduct,
    changeStockState,
  },
  created() {
    this.$validator = this.parentValidator;
  },
  mounted: function () {
    const { tester_product_id, tester_product_name } = this.productVariant;
    if (tester_product_id && tester_product_name) {
      this.selectTestProduct({ id: tester_product_id, name: tester_product_name });
    }
  },
};

function openVariantImageModal() {
  this.$emit("on-variant-image-modal-open");
}

function updateVariantValue(key) {
  this.$emit("on-update-variant-value", key, this.productVariant[key]);
  this.$forceUpdate();
}

function removeVariantFromList() {
  this.$emit("on-remove-variant");
  this.$forceUpdate();
}

function addTester() {
  this.$emit("on-add-tester");
  this.$forceUpdate();
}

function removeTester() {
  this.$emit("on-remove-tester");
  this.$forceUpdate();
}

function selectTestVariant(item) {
  this.$emit("on-select-test-variant", item);
  this.$forceUpdate();
}

async function selectTestProduct(product, clearVariant) {
  try {
    const response = await ProductApiService.getProduct(product.id);
    this.productVariant.tester_product_id = product.id;
    this.productVariant.tester_product_name = product.name;

    if (clearVariant) {
      this.productVariant.tester_variant_id = null;
      this.productVariant.tester_variant_name = "";
    }

    this.productVariant.testerVariants =
      response.data.variants.map(function (variant) {
        return {
          id: variant.id,
          name: Object.values(variant.characteristic_option).join(" "),
        };
      }) || [];

    this.$forceUpdate();
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
  }
}

function changeStockState() {
  this.$emit("on-update-variant-value", "in_stock", !this.productVariant.in_stock);
  this.$forceUpdate();
}
